const errorMsgTimeout = 3000;

function getErrorMessage(data) {
  if (data.errors && typeof data.errors === 'object') {
    return Object.values(data.errors).map((messages) => messages.join(', '));
  }

  return typeof data.description === 'string' ? data.description : data.message;
}

async function fetchCart() {
  const response = await fetch(`${window.theme.routes.cart}.js`);
  if (!response.ok) {
    throw new Error(response.status);
  }

  return response.json();
}

export class ConvermaxProductForm extends window.HTMLElement {
  constructor() {
    super();
    this.addEventListener('submit', (evt) => this.handleSubmit(evt));
    this.addEventListener('click', (evt) => {
      if (evt.target.closest('.cm_add-to-cart_error-close')) {
        this.setErrorMsgState();
      }
    });
  }

  async handleSubmit(evt) {
    const { routes, settings } = window.theme;
    if (settings.afterAtc === 'no-js') {
      return;
    }

    evt.preventDefault();

    const submitBtn = this.querySelector('[name="add"]');
    if (submitBtn.getAttribute('aria-disabled') === 'true') {
      return;
    }

    if (settings.vibrateOnATC && window.navigator.vibrate) {
      window.navigator.vibrate(100);
    }

    window.document.querySelectorAll('convermax-product-form').forEach((form) => form.setErrorMsgState());
    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('is-loading');

    const cartDrawer = window.document.querySelector('cart-drawer');
    const sections = ['cart-icon-bubble'];
    if (cartDrawer) {
      sections.push(cartDrawer.closest('.shopify-section').id.replace('shopify-section-', ''));
    }

    const formData = new FormData(evt.target);
    formData.append('sections_url', window.location.pathname);
    formData.append('sections', sections.join(','));

    try {
      const oldCart = await fetchCart();
      const response = await fetch(routes.cartAdd, {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const data = await response.json();

      if (data.status) {
        this.setErrorMsgState(getErrorMessage(data));
      }

      if (!response.ok) {
        throw new Error(response.status);
      }

      if (settings.afterAtc === 'page') {
        setTimeout(() => {
          window.location.href = routes.cart;
        }, 300);
      } else {
        ConvermaxProductForm.updateCartIcon(data);
        setTimeout(() => cartDrawer?.renderContents(data, settings.afterAtc === 'drawer'), 700);
      }

      const newCart = await fetchCart();
      const itemInOldCart = oldCart.items.find((item) => item.variant_id === data.variant_id);
      if (itemInOldCart) {
        this.dispatchEvent(
          new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCart,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: data.quantity,
            },
          }),
        );
      } else {
        this.dispatchEvent(
          new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: { cart: newCart, variantId: data.variant_id },
          }),
        );
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.debug(error);
      this.dispatchEvent(
        new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: this.querySelector('.js-form-error')?.textContent },
        }),
      );
      cartDrawer?.refresh(true);
    } finally {
      submitBtn.classList.add('is-success');
      submitBtn.removeAttribute('aria-disabled');
      setTimeout(() => submitBtn.classList.remove('is-loading', 'is-success'), 1400);
    }
  }

  static updateCartIcon(response) {
    const cartIconBubble = window.document.getElementById('cart-icon-bubble');
    if (cartIconBubble) {
      cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
    }
  }

  setErrorMsgState(error = false) {
    const errorPopup = this.querySelector('.cm_add-to-cart_error');
    if (!errorPopup) {
      return;
    }

    window.clearTimeout(this.errorMsgTimer);
    errorPopup.hidden = !error;
    errorPopup.togglePopover?.(Boolean(error));
    if (error) {
      const errorMsg = errorPopup.querySelector('.js-form-error');
      errorMsg.innerHTML = '';
      [error].flat().forEach((message, index) => {
        if (index > 0) {
          errorMsg.insertAdjacentHTML('beforeend', '<br>');
        }
        errorMsg.insertAdjacentText('beforeend', message);
      });
      this.errorMsgTimer = window.setTimeout(() => this.setErrorMsgState(), errorMsgTimeout);
    }
  }
}
